import { useIsMobile, useIsTablet } from '@hooks/responsive/useIsMobile';
import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import JobList from '@components/_templates/career/JobList';
import CareerDefaultLayout from '@components/_templates/career/DefaultLayout';
import PeopleBenefit from '@components/_templates/career/PeopleBenefit';
import Culture from '@components/_templates/career/Culture';

const Career: NextPage = () => {
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();
  const { t } = useTranslation('document');

  return (
    <>
      <CareerDefaultLayout>
        <Culture />
        <PeopleBenefit />
        <JobList isMain />
      </CareerDefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['document', 'common', 'component'])),
  },
});

export default Career;
